import React from "react";
import { PanelMenuProps } from "./panel-menu.types";
import { PanelMenuHeader } from "./panel-menu-header";
import { PanelMenuStandalone } from "./panel-menu-standalone";

export const PanelMenu = React.forwardRef<HTMLUListElement, PanelMenuProps>(
  (
    {
      children,
      className,
      data,
      navAriaLabel = "Panel Menu",
      _privateProps = {},
    },
    navListRef
  ) => {
    if (_privateProps.isHeader) {
      return <PanelMenuHeader ref={navListRef} _privateProps={_privateProps} />;
    }

    return (
      <PanelMenuStandalone
        data={data}
        ref={navListRef}
        className={className}
        navAriaLabel={navAriaLabel}
        _privateProps={_privateProps}
      >
        {children}
      </PanelMenuStandalone>
    );
  }
);

PanelMenu.displayName = "PanelMenu";
